import api from '@/services/api'
import type {
  RefAgentUrlResponse,
  UserFiltersUpdate,
  UserSettingsUpdate,
  UserSignalRequest,
} from './types'

export const UserV2Service = {
  getRefUrls(agent: string) {
    return api.get<RefAgentUrlResponse[]>(`/v2/user/ref-urls/${agent}/`)
  },
  saveUserSettings(data: UserSettingsUpdate) {
    return api.put('/v2/user/', data)
  },
  saveUserFilters(data: UserFiltersUpdate, prefix: string) {
    return api.put('/v2/user/filters', data, { params: { prefix } })
  },
  sendUserSignal(data: UserSignalRequest) {
    return api.put('/v2/user/signal', data)
  },
}
